export default "__VITE_ASSET__BLlPcJaH__"